import { GroupMode, Layout } from '../types/categorical-bar-chart.js';

/**
 * Boolean if Layout value is vertical or horizontal
 * @param layout - vertical or horizontal values
 * @returns true if layout has vertical value
 */
export function isVertical(layout: Layout) {
  return layout === 'vertical';
}

/**
 * Boolean if groupMode value is stacked
 * @param groupMode - grouped or stacked values
 * @returns true if groupMode has stacked value
 */
export function isStacked(groupMode: GroupMode) {
  return groupMode === 'stacked';
}

/**
 * Boolean if groupMode value is grouped
 * @param groupMode - grouped or stacked values
 * @returns true if groupMode has stacked value
 */
export function isGrouped(groupMode: GroupMode) {
  return groupMode === 'grouped';
}
